/**
 * /free-trial route.
 *
 * Thin route shell that mounts the TrialStatus feature component. All
 * rendering logic lives in `../features/free-trial/TrialStatus`.
 *
 * This file is intentionally self-contained — it exports its TanStack
 * `Route` instance which the router picks up via the file-based naming
 * convention set up in D01's scaffold. Because D01 currently ships a
 * programmatic router, we also export a plain `FreeTrialRoute` component
 * for callers that want to render it directly.
 */

import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { TrialStatus } from "../features/free-trial/TrialStatus";

export function FreeTrialRoute() {
	return (
		<main className="flex min-h-screen justify-center bg-zinc-50 px-6 py-12">
			<div className="flex w-full max-w-3xl flex-col gap-6">
				<TrialStatus />
			</div>
		</main>
	);
}

export const freeTrialRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/free-trial",
	component: FreeTrialRoute,
});
